export const GRID_BREAKPOINTS = {
    MOBILE: 0,
    SMALL: 600,
    SMALL_TO_MEDIUM: 1000,
    MEDIUM: 1300,
    LARGE: 1900,
};
